import { H, P, Wrapper } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'
import type { DocumentWithAttributes } from 'lib/models/document'
import { DocumentCardReview } from './document-card-review'

export const ReviewDocuments = ({
  reviewDocuments,
}: {
  reviewDocuments: DocumentWithAttributes[]
}) => {
  return (
    <Wrapper padding={['XL', 0]}>
      <H tag="h2" size="M" margin={['L', 0, 'S']} color={COLOR.BLACK}>
        Review and save documents
      </H>
      {reviewDocuments.length === 0 ? (
        <P>No items to review</P>
      ) : (
        <Wrapper tag="ul">
          {reviewDocuments.map((document) => (
            <DocumentCardReview key={document.id} document={document} />
          ))}
        </Wrapper>
      )}
    </Wrapper>
  )
}
